import React from "react";

const EmptyRoutes = () => {
  return <div></div>;
};

export default EmptyRoutes;
